import * as React from "react";
import { DataGrid, GridToolbar } from "@mui/x-data-grid";
import axios from "axios";
import { useState } from "react";
import "../../components/CommonDashboard.css";
import { useSelector, useDispatch } from "react-redux";
import DeleteIcon from "@mui/icons-material/Delete";
import {
  makeStyles,
  createMuiTheme,
  ThemeProvider,
} from "@material-ui/core/styles";
import EditIcon from "@material-ui/icons/Edit";
import { Button, Box, Typography } from "@mui/material";
import { CssBaseline } from "@material-ui/core";
import CopyAllIcon from "@mui/icons-material/CopyAll";
import { Tabs, Tab } from "@mui/material";
import {
  Dialog,
  DialogContent,
  DialogActions,
  IconButton,
} from "@mui/material";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import CloseIcon from "@mui/icons-material/Close";
import VisibilityIcon from "@mui/icons-material/Visibility";
import ConfirmationDialog from "../ConfirmationDialog";
import EditPlaylistForm from "./EditPlaylistForm";
import { setPlaylist } from "../../redux/slices/playlistSlice";
import MediaPreviewInPlaylist from "./MediaPreviewInPlaylist";
import { ArrowBack, ArrowForward } from "@mui/icons-material";
import { toast } from "react-toastify";
import { checkPrivileges } from "./Helpers/CheckPrivelges";
import TableStatus from "../TableStatus";



const theme = createMuiTheme({
  spacing: 5,
});

const useStyles = makeStyles((theme) => ({
  root: {
    "& .MuiDataGrid-row.Mui-selected": {
      backgroundColor: "#e0e0e0",
    },
    "& .MuiDataGrid-columnHeader": {
      backgroundColor: "#fafafa",
    },
    "& .MuiDataGrid-cell": {
      fontWeight: "normal",
      fontSize: "0.875rem",
      color: "rgba(0, 0, 0, 0.87)",

      letterSpacing: "0.01071em",
    },
    "& .MuiDataGrid-cell--textLeft": {
      textAlign: "left",
    },
    "& .MuiDataGrid-cell--textCenter": {
      textAlign: "center",
    },
    "& .MuiDataGrid-cell--textRight": {
      textAlign: "right",
    },
    "& .MuiDataGrid-columnsContainer": {
      backgroundColor: "#fafafa",
    },
    "& .MuiDataGrid-iconSeparator": {
      display: "none",
    },
  },
  table: {
    marginLeft: theme.spacing(1),
    marginRight: theme.spacing(1),
    width: `calc(100% - ${theme.spacing(9)}px)`,
  },
  modal: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    overflow: "hidden",
  },
  paper: {
    position: "relative ",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: 400,
    backgroundColor: theme.palette.background.paper,
    boxShadow: theme.shadows[5],
    padding: theme.spacing(2, 4, 3),
    alignItems: "center",
    marginTop: "10%",
    borderRadius: "5px",
  },
}));

const PlaylistTable = ({ selectedOption, errors, isLoading }) => {
  const [rows, setRows] = React.useState([]);
  const [loading, setLoading] = React.useState(false);
  const [expanded, setExpanded] = React.useState(false);
  const classes = useStyles();
  const dispatch = useDispatch();
  const api = localStorage.getItem("api");
  const emms = useSelector((state) => state.emms);
  const locationData = useSelector((state) => state.location);
  const headers = useSelector((state) => state.header);
  const emmsheaders = useSelector((state) => state.emmsheader);
  const eventcustomisationsData = useSelector(
    (state) => state.eventcustomisations
  );
  const playlist = useSelector((state) => state?.playlist?.playlist);
  const [showConfirmationDialog, setShowConfirmationDialog] = useState(false);
  const [deleteItemId, setDeleteItemId] = useState(null);
  const [selectedItemId, setSelectedItemId] = useState(null);
  const [duplicateItemId, setDuplicateItemId] = useState(null);
  const [items, setItems] = useState([]);
  const [page, setPage] = useState(1);
  const [currentPreviewIndex, setCurrentPreviewIndex] = useState(0);
  const [viewPlaylistId, setViewPlaylistId] = useState(null);
  const user = useSelector((state) => state?.user?.user);
  const groupIdsOfUser = user?.customProperties?.belongsTo || [];
  const [maker, setMaker] = useState("");
  const dataToDisplay = useSelector(
    (state) => state?.dataToDisplay?.dataToDisplay
  );

  

  const handleViewId = (id) => {
    setViewPlaylistId(id);
  };
  const columns = [
    {
      field: "name",
      headerName: "Name",
      width: 120,
    },
    {
      field: "Maker",
      headerName: "Maker",
      width: 120,
      renderCell: (params) => {
        return params?.row?.customProperties?.contentAiPlaylistMaker;
      },
    },
    {
      field: "Editor",
      headerName: "Editor",
      width: 120,
      renderCell: (params) => {
        return params?.row?.customProperties?.contentAiPlaylistEditor;
      },
    },
    {
      field: "view",
      headerName: "Playlist Content",
      width: 120,
      sortable: false,
      renderCell: (params) => (
        <Button
          variant="outlined"
          color="success"
          startIcon={<VisibilityIcon />}
          onClick={() => {
            handleViewImages(
              params?.row?.items?.map((c) => c.eventCustomisationId) || []
            );
            handleViewId(params.row.id);
          }}
        >
          View
        </Button>
      ),
    },
    {
      field: "duplicate",
      headerName: "Duplicate",
      width: 150,
      sortable: false,
      renderCell: (params) => (
        <Button
          variant="outlined"
          startIcon={<CopyAllIcon />}
          color="primary"
          onClick={() => handleDuplicate(params?.row?.id)}
          disabled={loading}
        >
          {loading ? "Duplicating..." : "Duplicate"}
        </Button>
      ),
    },

    {
      field: "delete",
      headerName: "Delete",
      width: 150,
      sortable: false,
      renderCell: (params) => (
        <Button
          variant="outlined"
          startIcon={<DeleteIcon />}
          color="error"
          onClick={() => {
            handleDelete(params?.row?.id);
            setMaker(params.row.customProperties?.contentAiPlaylistMaker);
          }}
          disabled={loading}
        >
          {loading ? "Deleting..." : "Delete"}
        </Button>
      ),
    },
    {
      field: "edit",
      headerName: "Edit",
      width: 100,
      sortable: false,
      renderCell: (params) => {
        const maker = params.row.customProperties?.contentAiPlaylistMaker;
        return (
          <Button
            variant="outlined"
            startIcon={<EditIcon />}
            color="primary"
            onClick={() =>{
                handleEdit(params?.row?.id, maker)
            } }
            disabled={loading}
          >
            {loading ? "Editing..." : "Edit"}
          </Button>
        );
      },
    },
  ];

  const handleEdit = async (id, maker) => {
    const hasRights = await checkPrivileges(
      maker,
      groupIdsOfUser,
      api,
      headers
    );

    if (!hasRights) {
      toast.error("Access Denied", {
        position: toast.POSITION.BOTTOM_RIGHT,
      });
      return;
    }
    setSelectedItemId(id);
  };
  const handleDuplicate = (id) => {
    setDuplicateItemId(id);
  };

  const handleDelete = (id) => {
    setDeleteItemId(id);
    setShowConfirmationDialog(true);
  };
  React.useEffect(() => {
    const selectedPlaylist = playlist?.find(
      (playlist) => playlist?.id === viewPlaylistId
    );

    if (selectedPlaylist) {
      setItems(
        selectedPlaylist?.items?.map((item) => ({
          customizationId: item.content_ref,
          duration: item.duration || 10,
        })) || []
      );
    }
  }, [playlist, viewPlaylistId]);

  const handleConfirmDelete = () => {
    setShowConfirmationDialog(false);
    setLoading(true);
    const requestBody = {
      path: "playlist",
      query: { id: `${deleteItemId}` },
      emmsId: selectedOption,
      body: {},
      requestType: "DELETE",
      headers: emmsheaders?.emmsheaders?.headers,
    };

    axios
      .post(api + `/emms/piggyback`, requestBody, headers)
      .then(() => {
        setRows((prevRows) => {
          const updatedRows = prevRows?.filter(
            (row) => row.id !== deleteItemId
          );
          dispatch(setPlaylist(updatedRows));
          return updatedRows;
        });
      })
      .catch((error) => {
        console.error(error);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const handleCancelDelete = () => {
    setShowConfirmationDialog(false);
  };

  const UUID_IN_STRING_REGEX =
    /[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}/i;

  React.useEffect(() => {
    if (playlist && Array.isArray(playlist)) {
      const filtered = playlist.filter((row) => {
        const name = row?.name|| "";
        return !UUID_IN_STRING_REGEX.test(name);
      });

      setRows(filtered);
    }
  }, [playlist]);

  const [openViewModal, setOpenViewModal] = useState(false);
  const [currentImages, setCurrentImages] = useState([]);
  const [currentImageIndex, setCurrentImageIndex] = useState(0);

  const handleViewImages = (eventCustomisationIds) => {
 
    const imagesOrVideos = eventCustomisationIds
      .map((id) => {
        const match = eventcustomisationsData?.eventcustomisations?.find(
          (item) => item.id === id
        );

        return match ? match.customisations[0].imageUrl : null;
      })
      .filter((url) => url); 

    setCurrentImages(imagesOrVideos);
    setCurrentImageIndex(0);
    setOpenViewModal(true);
  };

  const handleCloseViewModal = () => {
    setOpenViewModal(false);
    setCurrentImages([]);
    setCurrentImageIndex(0);
    setViewPlaylistId(null);
  };
  const goToPreviousPreview = () => {
    setCurrentPreviewIndex((prevIndex) =>
      prevIndex > 0 ? prevIndex - 1 : items.length - 1
    );
  };

  const goToNextPreview = () => {
    setCurrentPreviewIndex((prevIndex) =>
      prevIndex < items.length - 1 ? prevIndex + 1 : 0
    );
  };


  const handleNextImage = () => {
    setCurrentImageIndex((prevIndex) =>
      prevIndex < currentImages.length - 1 ? prevIndex + 1 : 0
    );
  };

  const handlePreviousImage = () => {
    setCurrentImageIndex((prevIndex) =>
      prevIndex > 0 ? prevIndex - 1 : currentImages.length - 1
    );
  };

  return (
    <>
      {rows?.length > 0 && errors === false ? (
        <CssBaseline>
          <ThemeProvider>
            <div className="emms-data-grid-container" style={{ padding: "2.5% 10%", overflowX: "auto" }}>
              <DataGrid
                rows={rows}
                columns={columns}
                initialState={{
                  pagination: {
                    paginationModel: {
                      pageSize: 5,
                    },
                  },
                }}
                pageSizeOptions={[5]}
                checkboxSelection
                disableRowSelectionOnClick
                slots={{ toolbar: GridToolbar }}
                slotProps={{
                  toolbar: {
                    showQuickFilter: true,
                  },
                }}
              />
            </div>
            {selectedItemId !== null && (
              <EditPlaylistForm
                selectedOption={selectedOption}
                selectedItemId={selectedItemId}
                playlist={playlist}
                handleClose={() => setSelectedItemId(null)} 
              />
            )}
            {duplicateItemId !== null && (
              <EditPlaylistForm
                selectedOption={selectedOption}
                duplicateItemId={duplicateItemId}
                playlist={playlist}
                duplicate={true}
                handleClose={() => setDuplicateItemId(null)} 
              />
            )}

            {showConfirmationDialog && (
              <ConfirmationDialog
                open={showConfirmationDialog}
                onClose={handleCancelDelete}
                onConfirm={handleConfirmDelete}
                contentAI={true}
                maker={maker}
              />
            )}

            <Dialog
              open={openViewModal}
              onClose={handleCloseViewModal}
              maxWidth="md"
            >
              <DialogActions>
                <IconButton onClick={handleCloseViewModal}>
                  <CloseIcon />
                </IconButton>
              </DialogActions>
              <DialogContent style={{ textAlign: "center" }}>
                {items?.length > 0 ? (
                  <>
                    <IconButton
                      sx={{
                        position: "absolute",
                        top: "50%",
                        left: 5,
                        transform: "translateY(-50%)",
                        zIndex: 1,
                      }}
                      onClick={goToPreviousPreview}
                    >
                      <ArrowBack />
                    </IconButton>
                    <Box
                      sx={{
                        width: "400px", 
                        height: "300px", 
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        overflow: "hidden",
                        border: "4px solid #4caf50",
                        backgroundColor: "#000", 
                      }}
                    >
                      <MediaPreviewInPlaylist
                        matchedRecord={dataToDisplay.find(
                          (data) =>
                            data.id ===
                            items[currentPreviewIndex]?.customizationId
                        )}
                      />
                    </Box>

                    <Typography
                      sx={{
                        position: "absolute",
                        bottom: 10,
                        left: "50%",
                        transform: "translateX(-50%)",
                        backgroundColor: "rgba(0, 0, 0, 0.5)",
                        color: "white",
                        padding: "5px",
                        borderRadius: "4px",
                      }}
                    >
                      {currentPreviewIndex + 1} / {items.length}
                    </Typography>
                    <IconButton
                      sx={{
                        position: "absolute",
                        top: "50%",
                        right: 5,
                        transform: "translateY(-50%)",
                        zIndex: 1,
                      }}
                      onClick={goToNextPreview}
                    >
                      <ArrowForward />
                    </IconButton>
                  </>
                ) : (
                  <Typography variant="subtitle1" color="textSecondary">
                    Select a customization to preview
                  </Typography>
                )}
              </DialogContent>
            </Dialog>
          </ThemeProvider>
        </CssBaseline>
      ) : (
        <TableStatus loading={isLoading} errors={errors} />
      )}
    </>
  );
};

export default PlaylistTable;
